export default {
    state: {
        alerts: [],
        idCounter: 0
    },
    getters: {
        alerts(state) {
            return state.alerts
        }
    },
    mutations: {
        GET_ALERTS(state) {
            return state.alerts
        },
        SET_ALERT(state, alert) {
            //Generate unique alert ID
            alert.id = state.idCounter++
            state.alerts.push(alert)
        },
        REMOVE_ALERT(state, alertId) {
            state.alerts = state.alerts.filter((alert) => {
                return (alert.id !== alertId)
            })
        }
    },
    actions: {
        GET_ALERTS(context) {
            return context.commit('GET_ALERTS')
        },
        ADD_ALERT(context, alert) {
            context.commit('SET_ALERT', alert)
        },
        REMOVE_ALERT(context, alertId) {
            context.commit('REMOVE_ALERT', alertId)
        }
    }
}